<script setup>
import { computed } from 'vue';

import { Tooltip, ProBadge } from '@components'
const props = defineProps({
    modelValue: {
        type: Boolean,
    },
    hints: {
        type: String,
    },
    locked: {
        type: Boolean,
        default: false,
    },
})

const isLocked = computed( () => {
    return props.locked && ! formychat_admin_vars.is_premium
})
</script>
<template>
    <div class="flex items-center gap-3">
        <div class="w-fit z-0 flex items-center gap-3 text-slate-800 cursor-pointer group" v-bind="$attrs" @click="isLocked ? null : (props.modelValue = !props.modelValue, $emit('update:modelValue', props.modelValue), $emit('change', props.modelValue))" :class="{'formychat-locked opacity-60' : isLocked}">
            <div class="rounded-full h-[18px] w-10 cursor-pointer relative transition"
                :class="{
                    'bg-indigo-600 border border-indigo-600': props.modelValue,
                    'bg-slate-200 border border-slate-200': !props.modelValue
                }">
                <span
                    class="bg-white ring-1 group-active:scale-95 ring-gray-200 shadow group-hover:shadow-lg w-[22px] h-[22px] rounded-full flex absolute z-0 top-1/2 -translate-y-1/2 scale-110 transition duration-200"
                    :class="{
                        'translate-x-full ': props.modelValue,
                    }"></span>
            </div>
            <slot  />
        </div>
        <Tooltip v-if="props.hints">
            <div v-html="props.hints"></div>
        </Tooltip>
        <ProBadge v-if="props.locked"/>
    </div>
</template>